import { useTranslation } from 'react-i18next';
import { SELETOR_CONTEUDO, SELETOR_PAINEL_ATIVO } from '../nucleo/foco';

/**
 * Review r29 visual (B3, WCAG 2.4.1): primeira parada do Tab no web e no portal. Escondido até receber o foco; leva ao
 * `<main id="conteudo">` sem passar pelas cerca de 20 paradas do menu e da barra.
 */
export function PularParaConteudo() {
  const { t } = useTranslation('nucleo');
  return (
    <a
      href={SELETOR_CONTEUDO}
      data-pular-conteudo=""
      onClick={(e) => {
        // Sem mudar a URL (o hash ficaria no endereço e no voltar): foca o conteúdo direto. Lote 19 (tela dividida): o painel
        // ativo, o que tem o foco da pessoa (sem tela dividida, o próprio `#conteudo`).
        const alvo = document.querySelector<HTMLElement>(SELETOR_PAINEL_ATIVO) ?? document.querySelector<HTMLElement>(SELETOR_CONTEUDO);
        if (!alvo) return;
        e.preventDefault();
        alvo.focus();
        alvo.scrollIntoView({ block: 'start' });
      }}
      className="sr-only rounded-md border border-borda bg-sup-1 text-sm font-medium text-tinta-1 shadow-lg focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50"
    >
      {/* Review r30 visual (B3): o `focus:not-sr-only` zera o padding do próprio link (0,2,0 vence `px-3`); o espaço fica no span. */}
      <span className="block px-3 py-2">{t('pular.conteudo')}</span>
    </a>
  );
}
